import html2canvas from "html2canvas";

export const downloadElementAsImage = async (
  element,
  filename,
  format = "png"
) => {
  if (!element) return;

  const canvas = await html2canvas(element);
  const isJpeg = format === "jpeg" || format === "jpg";
  const mimeType = isJpeg ? "image/jpeg" : "image/png";
  const data = canvas.toDataURL(mimeType, isJpeg ? 0.92 : undefined);

  const link = document.createElement("a");
  link.href = data;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
